import { IViewItemGA4Item } from "../../ui/models/IViewItemGA4Item";
import Helpers from "./helpers";

declare var dataLayer: any;

export default class Tracking {

	public static trackListView(listId: string, listName: string, items: any) {

		Helpers.deferTask(() => {
			dataLayer.push({ ecommerce: null });
			dataLayer.push({
				event: "view_item_list",
				ecommerce: {
					item_list_id: listId,
					item_list_name: listName,
					items: items
				}
			});
		});

	}

	public static trackSelectItem(listId: string, listName: string, item: any) {
		Helpers.deferTask(() => {
			dataLayer.push({ ecommerce: null });
			dataLayer.push({
				event: "select_item",
				ecommerce: {
					item_list_id: listId,
					item_list_name: listName,
					items: [item]
				}
			});
		});
	}

	public static getItemDetails(product: HTMLDivElement) {
		return {
			item_id: product.getAttribute('data-product-id'),
			item_name: product.getAttribute('data-product-name'),
			price: parseFloat(product.getAttribute('data-product-price'))
		}
	}

	public static trackShare(method: string, contentType: string, id: string) {
		Helpers.deferTask(() => {
			dataLayer.push({ ecommerce: null });
			dataLayer.push({
				event: "share",
				ecommerce: {
					method: method,
					content_type: contentType,
					item_id: id
				}
			});
		});
	}

	public static addCampaignTracking(url: string, source: string, medium: string, campaign: string, content?: string) {
		let outputUrl = new URL(url);
		outputUrl.searchParams.append('utm_source', source);
		outputUrl.searchParams.append('utm_medium', medium);
		outputUrl.searchParams.append('utm_campaign', campaign);
		if (content) {
			outputUrl.searchParams.append('utm_content', content);
		}
		return outputUrl.toString();
	}

	public static customEvent(eventName: string, customObject: object) {
		Helpers.deferTask(() => {
			dataLayer.push({
				event: eventName,
				...customObject
			});
		});
	}

	public static trackViewItem(price: number, data: IViewItemGA4Item[]) {
		Helpers.deferTask(() => {
			dataLayer.push({
				event: "view_unique_item",
				view_item_price: price,
				view_item_data: data
			});
		});
	}

}
